import { createIconfieldTokens } from '../tokens/components.js';
import { SEMANTIC, type SemanticTokens } from '../tokens/semantic.js';

/**
 * IconField Component Configuration
 * Wrapper component for input fields with icons
 */
export function createIconfield(s: SemanticTokens) {
  const iconfieldTokens = createIconfieldTokens(s);
  return {
    icon: {
      color: iconfieldTokens.iconFg,
    },
    css: () => `
    .p-inputicon {
      top: 30%;
      margin-top: 0rem;
      font-size: ${iconfieldTokens.icon.size};
    }
  `,
  };
}
export const iconfield = createIconfield(SEMANTIC);
